// extracted by mini-css-extract-plugin
export default {"main":"FilterValueTag-module_main_bf90ec99"};